import { render, staticRenderFns } from "./taskHistory.vue?vue&type=template&id=48eb6ea2&"
import script from "./taskHistory.vue?vue&type=script&lang=js&"
export * from "./taskHistory.vue?vue&type=script&lang=js&"
import style0 from "./taskHistory.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports